import React from "react"

import "./modal-info.scss"

export default function ModalInfo(props) {
  const { title, body } = props
  return (
    <div className="modal-info">
      <div className="modal-info-container">
        <div className="wrapper-star">
          <h2 className="wrapper-star__title">{title}</h2>
          <div className="wrapper-star__body">{body}</div>
        </div>
      </div>
    </div>
  )
}
